import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import cfac22 from 'js/library/utils/cfac22';

import 'react-toastify/dist/ReactToastify.css';

//area logada
import Home from 'js/components/Home/Home';
import { Store } from 'js/components/StorePlaces/Store';
import Places from 'js/components/StorePlaces/Places';
import StorePlacesLists from 'js/components/StorePlaces/StorePlacesLists';
import Wallet from 'js/components/Wallet/Wallet';
import Voucher from 'js/components/Wallet/Voucher';
import Inbox from 'js/components/Inbox/Inbox';
import Organizations from 'js/components/Organizations/Organizations';
import AddOrganizations from 'js/components/Organizations/AddOrganizations';
import HowToUse from 'js/components/HelpPages/HowToUse';
import About from 'js/components/HelpPages/About';
import TalkWithUs from 'js/components/HelpPages/TalkWithUs';

//CAMPANHAS
import SharePromotions from 'js/components/Campaigns/SharePromotions';
import { CampaignImagePollsApproval } from 'js/components/Campaigns/CampaignImagePollsApproval';

import {
  debounce,
  getCurrentDirectory,
  loginRedirectKey,
  trackEventMatomo,
} from 'js/library/utils/helpers';
import { AddressForm } from '../AddressForm/AddressForm';
import CodeInput from 'js/components/LoginForms/CodeInput';
import PhoneInput from 'js/components/LoginForms/DynamicIdentifierInput';
import DynamicEditUser from 'js/components/LoginForms/DynamicEditUser';
import DynamicCreateUser from 'js/components/LoginForms/DynamicCreateUser';
import InformCellphone from 'js/components/LoginForms/InformCellphone';

import PaymentPage from 'js/components/PaymentPage';
import PaymentConfirmed from 'js/components/PaymentPage/PaymentConfirmed';
import { QRCodeReader } from 'js/components/QRCodeReader/QRCodeReader';
import { useCurrentUserInfo } from 'js/library/services/currentUserInfo';
import { getSeuClube } from 'js/library/utils/API/getSeuClube';
import LandingPagePuck from 'js/components/Campaign/LandingPagePuck';

// seuclubeapps
import {
  Register,
  NotAccessGeneric,
  ListRegisteredNotesGeneric,
  // ListVouchers,
} from '@sysmobil/synoro-packages';

export default function LoggedRoutes(props) {
  const { setOpenState } = props;
  const { userInfo } = useCurrentUserInfo();
  const [infosSeuClube, setInfosSeuClube] = useState(null);
  const isUserLogged = Boolean(userInfo?.uId);

  const location = useLocation();
  const homeLandingPage = infosSeuClube?.homeLandingPage;
  const hasPuckHome = homeLandingPage?.type === 'pucklp' && homeLandingPage?.landingPageId;
  const isMeusDados = /^\/meusDados\/?$/.test(location.pathname);

  useEffect(() => {
    if (!isUserLogged && ['/registrar-voucher', '/lista-de-notas'].includes(location.pathname)) {
      sessionStorage.setItem(loginRedirectKey, getCurrentDirectory());
    }
  }, [isUserLogged, location.pathname]);

  useEffect(() => {
    getSeuClube(null, 'home')
      .then((clubInfo) => setInfosSeuClube(clubInfo))
      .catch((error) => {
        console.error('Erro ao carregar dados do clube:', error);
      });
  }, []);

  useEffect(() => {
    document.addEventListener(
      'scroll',
      debounce(function (event) {
        const titlePage = event.target.title;

        trackEventMatomo(titlePage, 'scroll', 'lista', titlePage.toLowerCase());
      }, 400)
    );
  }, []);

  function RedirectRegistrarVenda() {
    const location = useLocation();
    return <Navigate to={`/registrar-voucher${location.search}`} replace />;
  }

  function RedirectAnonymousToLogin() {
    const currentDirectory = sessionStorage.getItem(loginRedirectKey) || getCurrentDirectory();
    const loginUrl = currentDirectory === '%2F' ? '/login' : `/login?url=${currentDirectory}`;

    return <Navigate to={loginUrl} replace />;
  }

  const routes = (
    <Routes>
      {/* <ToastContainer autoClose={4000} /> */}
        <Route
          path="/"
          element={
            hasPuckHome ? <LandingPagePuck campaignId={homeLandingPage.landingPageId} /> : <Home />
          }
        />

        <Route path="/home" element={<Home />} />

        <Route path="/login" element={<PhoneInput />} />

        <Route path="/inserirCodigo" element={<CodeInput />} />
        <Route path="/informarCelular" element={<InformCellphone />} />

        <Route path="/cadastroUsuario" element={<DynamicCreateUser />} />

        <Route path="/carteira" element={<Wallet />} />

        <Route path="/carteira/detalhes/:id" element={<Voucher />} />

        <Route path="/meusDados" element={<DynamicEditUser />} />

        <Route path="/caixaDeEntrada" element={<Inbox />} />

        <Route path="/ofertas/" element={<StorePlacesLists />} />

        <Route path="/oferta/" element={<Store setOpenState={setOpenState} />} />

        <Route path="/estabelecimento/" element={<Places setOpenState={setOpenState} />} />

        <Route path="/pagamento" element={<PaymentPage setOpenState={setOpenState} />} />

        <Route path="/pagamento-confirmado" element={<PaymentConfirmed />} />

        <Route
          path="/triibos"
          key={window.location.pathname}
          element={<Organizations setOpenState={setOpenState} reloadOrgs={props.reloadOrgs} />}
        />

        <Route path="/addTriibos" element={<AddOrganizations />} />

        <Route path="/como-usar" element={<HowToUse />} />

        <Route path="/sobre" element={<About />} />

        <Route path="/fale-conosco" element={<TalkWithUs />} />

        <Route path="/endereco" element={<AddressForm />} />

        <Route path="/image-approval" element={<CampaignImagePollsApproval />} />

        <Route path="/share-promo" element={<SharePromotions setOpenState={setOpenState} />} />

        <Route path="/leitor-qrCode" element={<QRCodeReader />} />

        {/* Seu Clube Apps packages  */}
        <Route
          path="/not-access"
          element={
            isUserLogged ? (
              <div className="paper-container">
                <NotAccessGeneric ambient={cfac22('ambient')} isUserLogged={isUserLogged} />
              </div>
            ) : (
              <RedirectAnonymousToLogin />
            )
          }
        />
        <Route path="/registrar-venda" element={<RedirectRegistrarVenda />} />
        <Route
          path="/registrar-voucher"
          element={
            <div className="paper-container">
              <Register ambient={cfac22('ambient')} isUserLogged={isUserLogged} />
            </div>
          }
        />
        {/* lista de vouchers (telas de aprovação)*/}
        <Route
          path="/lista-de-notas"
          element={
            <div className="paper-container">
              <ListRegisteredNotesGeneric ambient={cfac22('ambient')} isUserLogged={isUserLogged} />
            </div>
          }
        />
        <Route exact path="/landing/:publicName" element={<LandingPagePuck />} />
    </Routes>
  );

  return isMeusDados ? routes : <div className="paper-container">{routes}</div>;

}
